module.exports = __webpack_public_path__ + "/static/assets/905aaa5ec7fca7cf364f5e74bcb10be1.png";